<vectronic-filter-header
  (titleClicked)="toggleFilter()"
  [title]="title()"
  (enabledFilterToggle)="toggleFilter()"
  [isFilterEnabled]="!isFilterHidden()"
  [icon]="icon()"
  [svgIcon]="svgIcon()"
></vectronic-filter-header>
<div class="filter-body" [hidden]="isFilterHidden()">
  <vectronic-chips-filter
    [items]="availableFilterItems()"
    [defaultSelectedItems]="selectedFilterItems()"
    (selectItem)="onSelectItem($event)"
    (deleteItem)="onDeleteItem($event)"
  ></vectronic-chips-filter>
</div>
